export default __webpack_public_path__ + "static/heroBg-cfa330d693fb91a29cb41206c95b7c39.png";